import { MenuItem } from "@material-ui/core";
import { NodeModel } from "@minoru/react-dnd-treeview";
import React, { type Dispatch, useState } from "react";
import { TagFromTree } from "../../../../models/TagsTree.model";
import { useTagsTreeModalStyles } from "../../../../styles/TasgTreeModalStyles";
import { NewFolderModal } from "./NewFolder/NewFolder";
import { RemoveFolderModal } from "./RemoveFolder/RemoveFolder";

interface Props {
	isOpen: boolean;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
	anchorPoint: { x: number; y: number } | null;
	getTagsTreeData: Function;
	setShowContextMenu: Dispatch<boolean>;
}

export const ContextMenu = ({
	isOpen,
	anchorPoint,
	tagNodeSelectedInTree,
	getTagsTreeData,
	setShowContextMenu,
}: Props) => {
	const classes = useTagsTreeModalStyles();

	const [showNewTagModal, setShowNewTagModal] = useState<boolean>(false);
	const [showRemoveTagModal, setShowRemoveTagModal] = useState<boolean>(false);
	const isFolder = tagNodeSelectedInTree?.data?.TagTypeCode === "F";

	return (
		<>
			{isOpen && anchorPoint ? (
				<ul
					className={classes.contextMenu}
					style={{ top: anchorPoint.y, left: anchorPoint.x }}
				>
					<MenuItem
						style={{ width: "100%", justifyContent: "left" }}
						onClick={() => setShowNewTagModal(true)}
					>
						New Folder
					</MenuItem>
					{tagNodeSelectedInTree && isFolder && (
						<MenuItem
							style={{ width: "100%", justifyContent: "left" }}
							onClick={() => setShowRemoveTagModal(true)}
						>
							Remove Folder
						</MenuItem>
					)}
				</ul>
			) : null}
			<NewFolderModal
				open={showNewTagModal}
				handleClose={(shouldUpdate) => {
					if (shouldUpdate) {
						getTagsTreeData();
					}
					setShowContextMenu(false);
					setShowNewTagModal(false);
				}}
				tagNodeSelectedInTree={tagNodeSelectedInTree}
			/>
			<RemoveFolderModal
				open={showRemoveTagModal}
				handleClose={(shouldUpdate) => {
					if (shouldUpdate) {
						getTagsTreeData();
					}
					setShowContextMenu(false);
					setShowRemoveTagModal(false);
				}}
				tagNodeSelectedInTree={tagNodeSelectedInTree}
			/>
		</>
	);
};
